import { Dialog } from "@rmwc/dialog";
import "@rmwc/dialog/styles";
import { forwardRef, ReactNode, useImperativeHandle, useState } from "react";

import styles from "./SimpleDialog.module.scss";

export const SimpleDialogComponent = forwardRef(
  (props: { children: ReactNode }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog: () => {
        setOpen(true);
      },
      closeDialog: () => {
        setOpen(false);
      },
    }));

    return (
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        className={styles.dialog}
      >
        <span
          className="flex justify-center align-center pb-1 text-lg text-white absolute w-6 h-6 -top-3 -right-3 rounded-full bg-red-600"
          onClick={() => {
            setOpen(false);
          }}
        >
          x
        </span>
        <div className="h-full overflow-y-auto">{props.children}</div>
      </Dialog>
    );
  }
);
